'use client';

import { ReactNode } from 'react';
import { useIsMobile } from '@/components/DeviceContext';

interface Props {
  desktop: ReactNode;
  mobile: ReactNode;
}

export function DeviceSwitch({ desktop, mobile }: Props) {
  const isMobile = useIsMobile();
  return isMobile ? mobile : desktop;
}
